import { api } from "api/apiService";

// ==================== System & Users ====================

/**
 * Отримати список джерел (магазинів)
 */
export const fetchSources = () => api.get("/sources");

/**
 * Отримати список категорій
 */
export const fetchCategories = () => api.get("/categories");

// ==================== Bot Settings ====================

/**
 * Отримати налаштування бота (General + Role Logic)
 */
export const fetchBotSettings = () => api.get("/bot/settings");

/**
 * Оновити налаштування за ключем
 * @param {string} key - Ключ налаштування (напр. 'stats_lookback_days')
 * @param {string} value - Нове значення
 */
export const updateBotSetting = (key, value) =>
  api.put(`/bot/settings/${key}`, { value });

// ==================== Cancellation Queue ====================

/**
 * Отримати активну чергу скасувань
 */
export const fetchCancellationQueue = () => api.get("/bot/cancellation-queue");

/**
 * Отримати архів скасувань з пагінацією
 * @param {number} page - Номер сторінки
 * @param {number} pageSize - Розмір сторінки
 */
export const fetchCancellationArchive = (page = 1, pageSize = 50) =>
  api.get("/bot/cancellation-queue/archive", {
    page,
    page_size: pageSize,
  });

/**
 * Створити запит на скасування
 * @param {Object} payload - { type: 'clean'|'change', description: {...} }
 */
export const createCancellationRequest = (payload) =>
  api.post("/bot/cancellation-queue", payload);

/**
 * Видалити запит зі черги
 * @param {number} id - ID запиту
 */
export const deleteCancellationRequest = (id) =>
  api.delete(`/bot/cancellation-queue/${id}`);

// ==================== Managers ====================

/**
 * Отримати список менеджерів з фільтрацією
 */
export const fetchManagers = (params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value != null && value !== ""),
  );
  return api.get("/bot/managers", cleanParams);
};

/**
 * Оновити онлайн-статус менеджера
 * @param {number} id - ID менеджера
 * @param {boolean} isOnline - true/false
 */
export const updateManagerStatus = (id, isOnline) =>
  api.put(`/bot/managers/${id}/status`, { is_online: isOnline });

/**
 * Оновити персональні налаштування менеджера
 * @param {number} id - ID менеджера
 * @param {Object} settings - Об'єкт налаштувань
 */
export const updateManagerSettings = (id, settings) =>
  api.put(`/bot/managers/${id}/settings`, { personal_settings: settings });
